'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSystemUpdateAlt = function ActionSystemUpdateAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
  );
};
ActionSystemUpdateAlt = (0, _pure2.default)(ActionSystemUpdateAlt);
ActionSystemUpdateAlt.displayName = 'ActionSystemUpdateAlt';
ActionSystemUpdateAlt.muiName = 'SvgIcon';

exports.default = ActionSystemUpdateAlt;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/system-update-alt.js
// module id = 2633
// module chunks = 0